module.exports = __webpack_public_path__ + "img/security.c1caa452.png";